import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isLandingPath, normalizePublicPath, canonicalPath, languageAlternates, pageJsonLd, publicPages, siteOrigin, socialImage, socialImageAlt } from '../../services/publicSite';
const setMeta = (attribute: 'name' | 'property', name: string, content: string) => {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${name}"]`);
  if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, name); document.head.appendChild(element); }
  element.content = content;
};
const PageMetadata = () => {
  const { pathname: rawPathname } = useLocation();
  const pathname = normalizePublicPath(rawPathname);
  useEffect(() => {
    const page = publicPages[pathname];
    const language = page?.language || 'ro';
    document.documentElement.lang = language;
    document.title = page?.title || 'Contul tău · Orarivo';
    setMeta('name', 'description', page?.description || 'Acces securizat în aplicația Orarivo.');
    setMeta('name', 'robots', page ? 'index,follow,max-image-preview:large' : 'noindex,nofollow');
    setMeta('property', 'og:title', page?.title || 'Orarivo');
    setMeta('property', 'og:description', page?.description || 'Acces în Orarivo.');
    setMeta('property', 'og:url', `${siteOrigin}${canonicalPath(pathname)}`);
    setMeta('property', 'og:locale', language === 'en' ? 'en_GB' : 'ro_RO');
    setMeta('property', 'og:image', socialImage);
    setMeta('property', 'og:image:alt', socialImageAlt(language));
    setMeta('name', 'twitter:title', page?.title || 'Orarivo');
    setMeta('name', 'twitter:description', page?.description || 'Acces în Orarivo.');
    setMeta('name', 'twitter:image', socialImage);
    setMeta('name', 'twitter:image:alt', socialImageAlt(language));
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (page) {
      if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
      canonical.href = `${siteOrigin}${canonicalPath(pathname)}`;
    } else canonical?.remove();
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(element => element.remove());
    if (isLandingPath(pathname)) languageAlternates.forEach(alternate => {
      const link = document.createElement('link'); link.rel = 'alternate'; link.hreflang = alternate.language;
      link.href = `${siteOrigin}${canonicalPath(alternate.path)}`; document.head.appendChild(link);
    });
    let schema = document.getElementById('orarivo-schema');
    if (page) {
      if (!schema) { schema = document.createElement('script'); schema.id = 'orarivo-schema'; schema.setAttribute('type', 'application/ld+json'); document.head.appendChild(schema); }
      schema.textContent = JSON.stringify(pageJsonLd(pathname));
    } else schema?.remove();
  }, [pathname]);
  return null;
};
export default PageMetadata;
